import { Injectable, inject } from '@angular/core';
import settings from '../../../../settings.json';
import { LocalStorageService } from './local-storage.service';

export interface Language {
  id: string;
  title: string;
  flag: string;
}

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private _currentLanguage: string;
  private _languages: Language[];
  private _localStorageService = inject(LocalStorageService);

  public constructor() {
    this._currentLanguage = 'fr';
    this._languages = [
      /*{
          id   : 'en',
          title: 'English',
          flag : 'us'
      },*/
      {
        id: 'fr',
        title: 'Français',
        flag: 'fr',
      } /*,
      {
        id   : 'pt',
        title: 'português',
        flag : 'pt'
      }*/,
    ];
  }

  // https://stackoverflow.com/questions/34907682/how-to-display-the-app-version-in-angular
  public get version(): string {
    return settings.version;
  }

  public getDefaultLanguage(): string {
    return 'fr';
  }

  public getLanguage(): string {
    const language = this._localStorageService.read('language');
    if (language) {
      this._currentLanguage = language as string;
    } else {
      this._currentLanguage = this.getDefaultLanguage();
    }

    return this._currentLanguage;
  }

  public getSupportedLanguageIds(): string[] {
    return this._languages.map((language) => language.id);
  }

  public getSupportedLanguages(): Language[] {
    return this._languages;
  }

  public setLanguage(language: string): void {
    this._localStorageService.write('language', language);
  }
}
